"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuItemCheckboxClassNames: function() {
        return menuItemCheckboxClassNames;
    },
    useMenuItemCheckboxStyles_unstable: function() {
        return useMenuItemCheckboxStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _index = require("../../selectable/index");
const _useMenuItemStylesstyles = require("../MenuItem/useMenuItemStyles.styles");
const menuItemCheckboxClassNames = {
    root: 'fui-MenuItemCheckbox',
    icon: 'fui-MenuItemCheckbox__icon',
    checkmark: 'fui-MenuItemCheckbox__checkmark',
    content: 'fui-MenuItemCheckbox__content',
    secondaryContent: 'fui-MenuItemCheckbox__secondaryContent'
};
const useMenuItemCheckboxStyles_unstable = (state)=>{
    'use no memo';
    state.root.className = (0, _react.mergeClasses)(menuItemCheckboxClassNames.root, state.root.className);
    if (state.content) {
        state.content.className = (0, _react.mergeClasses)(menuItemCheckboxClassNames.content, state.content.className);
    }
    if (state.secondaryContent) {
        state.secondaryContent.className = (0, _react.mergeClasses)(menuItemCheckboxClassNames.secondaryContent, state.secondaryContent.className);
    }
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(menuItemCheckboxClassNames.icon, state.icon.className);
    }
    if (state.checkmark) {
        state.checkmark.className = (0, _react.mergeClasses)(menuItemCheckboxClassNames.checkmark, state.checkmark.className);
    }
    (0, _useMenuItemStylesstyles.useMenuItemStyles_unstable)(state);
    (0, _index.useCheckmarkStyles_unstable)(state);
    return state;
}; //# sourceMappingURL=useMenuItemCheckboxStyles.styles.js.map
